export default __webpack_public_path__ + "static/media/Cape of Atlantis.fc1f372e.jpg";